const _MS_PER_DAY = 1000 * 60 * 60 * 24

module.exports = function dateDiffInDays (a, b) {
  // Discard the time and time-zone information.
  let utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate())
  let utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate())

  return Math.floor((utc2 - utc1) / _MS_PER_DAY)
}
